// Generated cenary https://quicktype.io
// This one a bit trickier to generate.
// 1. Regex search for //.* in scenarioDTO.js to remove // comment lines.
// 2. Take main json object in scenarioDTO.js paste into: http://www.fixjson.com/
// 3. Paste into IScenarioData.json temp file.
// 4. Now CTRL+SHIFT+P "Paste Json As Types" via QuickType plugin.

import {
  Bitt,
  BittProfile as FleetBittProfile,
  Fairlead as FleetFairlead,
  Line as FleetLine,
  LineProfile as FleetLineProfile,
  PedestalFairlead as FleetPedestalFairlead,
  TailProfile as FleetTailProfile,
  Winch as FleetWinch,
  WinchProfile as FleetWinchProfile,
  Loading
} from './FleetManagerVessel';
import { MotionCriterion, WaveMatrixConditionBuoy } from './PortData';
import { ScenarioContainer } from './ScenarioContainer';
import { ConstantTensionWinchProfile } from './types';

// ----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v10.1.5.0 (Newtonsoft.Json v12.0.0.0) (http://NJsonSchema.org)
// </auto-generated>
// ----------------------

export interface LineProfile extends FleetLineProfile {
  edited?: boolean;
}
export interface TailProfile extends FleetTailProfile {
  edited?: boolean;
}
export interface WinchProfile extends FleetWinchProfile {
  edited?: boolean;
}
export interface BittProfile extends FleetBittProfile {
  edited?: boolean;
}

export interface Line extends FleetLine {
  fairleadId: number | undefined;
  name?: string;
  id?: number;
  fairleadWinchLength?: number;
  bollardFairleadLength?: number;
  bollardIndex?: number | undefined;
  selected?: boolean;
  shoreTension?: ShoreTension;
  bittIndex?: number | undefined;
  pretension?: number;
  lineName?: string;
}

export interface ShoreTension {
  enabled: boolean;
  bollardIndex: number;
  constantTensionWinchProfileId: number;
}

export interface Fairlead extends FleetFairlead {
  pathSelected?: string;
}

enum MotionType {
  CentreOfGravity = 0,
  Manifold = 1,
}

export interface Mooring {
  maxFenderThickness: number;
  dynamic: boolean;
  terminalName: string;
  motionType: MotionType;
  berthName: string;
  primaryBerthMarker: string;
  bowMarker: number;
  centerMarker: number;
  berthMarker: number;
  sternMarker: number;
  portDock: boolean;
  startTime: string;
  endTime: string;
  defaultMooringArrangementName: string;
  mooringArrangementName: string;
  mooringArrangements: { [key: string]: Line[] };
  originalMooringArrangementNames?: string[];
  linePretensionType: number;
  linePretensionValue: number;
  linePretensionMin: number;
  linePretensionMax: number;
  linePretensionBinSize: number;
  mooredHeading: number;
  longitude: number;
  latitude: number;
  idealBollards?: any;
  outreachBeyondBeam: number;
  spreaderClearance?: number;
  spreaderClearanceMin?: number;
  spreaderClearanceMax?: number;
  underKeelClearance?: number;
  underKeelClearanceMin?: number;
  underKeelClearanceMax?: number;
  deckAboveWharf?: number;
  deckAboveWharfMin?: number;
  deckAboveWharfMax?: number;
  dredgeDepth: number;
  dredgeDepthMsl: number;
  maxBeamExceeded: boolean | null;
  maxLoaExceeded: boolean | null;
  calculatedFields: string[];
  craneStaging?: CraneStaged[];
}

export interface CraneStaged {
  shipLoaderId: number;
  shipLoaderName: string;
  railToFender: number;
  maxWindSpeedOperational: number;
  widthLegs: number;
  berthMarkerCenter: number;
  enabled: boolean;
  primaryBerth: boolean;
}

export interface Vessel {
  vesselName: string;
  imo: string;
  teu: number;
  lineProfiles: LineProfile[];
  tailProfiles: TailProfile[];
  winchProfiles: WinchProfile[];
  bittProfiles: BittProfile[];
  fairleads: Fairlead[];
  winches: FleetWinch[];
  bitts?: Bitt[];
  pedestalFairleads: FleetPedestalFairlead[] | undefined;
  loa: number;
  deckLength: number;
  beam: number;
  lpp: number;
  bridgeToBow: number;
  manifoldToBow?: number;
  bridgeHeight: number;
  bridgeLength: number;
  heightOfPilotHouse: number;
  heightAbovePilotHouse: number;
  draftForeValue: number;
  draftMidValue: number;
  draftAftValue: number;
  draftType: number;
  draftMin: number;
  draftMax: number;
  draftBinSize: number;
  displacement: number;
  deadweightTonnage: number;
  geometricCentreHeight: number;
  gyrationRadiiX: number;
  gyrationRadiiY: number;
  gyrationRadiiZ: number;
  vesselType: number;
  vesselTypeName: string;
  mouldedDepth: number;
  hatchHeightAboveMainDeck: number;
  freeboard: number;
  blockCoefficient: number;
  deckPlane: Point2D[];
  summerDraft: number;
  capacityTiersAboveDeck: number;
  capacityTiersBelowDeck: number;
  numberOfContainerTiers: number;
  containerHeight: number;
  totalHeightAboveWaterLevel?: number;
  containerHeightAboveWl?: number;
  transverseWindageArea?: number;
  transverseWindageAreaMin?: number;
  transverseWindageAreaMax?: number;
  longitudinalWindageArea?: number;
  longitudinalWindageAreaMin?: number;
  longitudinalWindageAreaMax?: number;
  longitudinalWindageAreaCalculated?: number;
  transverseWindageAreaCalculated?: number;
  loading?: Loading;
}

export interface Point2D {
  x: number;
  y: number;
}

export interface Point3D {
  x: number;
  y: number;
  z: number;
}

export interface Port {
  name: string;
  fenderProfiles: FenderProfile[];
  constantTensionWinchProfiles: ConstantTensionWinchProfile[];
  constantTensionWinchLineProfiles: LineProfile[];
  fenders: Fender[];
  bollardProfiles: BollardProfile[];
  bollards: Bollard[];
  bollardsUnused: Bollard[];
  waterTemperature: number;
  airTemperature: number;
  salinity: number;
  varyPretension: boolean;
  waveMatrixConditionPaths: WaveMatrixConditonPath[];
  motionCriteria: MotionCriteria[] | MotionCriterion[];
  utmProjection: string;
}

export interface WaveMatrixConditonPath {
  index: number;
  path: string;
  buoys: WaveMatrixConditionBuoy[];
}

export interface Fender {
  id: number;
  coordinates: Point3D;
  profileId: number;
  direction: number;
  fenderOffset: number;
}

export interface FenderProfile {
  fenderType: string;
  deflectionReactionCurve: Point2D[];
  maximumReactionForce: number;
  maximumDeflection: number;
  failurePct: number;
  warningPct: number;
  frictionCoefficientType: number;
  frictionCoefficientValue: number;
  frictionCoefficientMin: number;
  frictionCoefficientMax: number;
  frictionCoefficientBinSize: number;
  thickness: number;
  fenderProfileId: number;
}

export interface Bollard {
  id: number;
  coordinates: Point3D;
  profileId: number;
  name?: string;
  originalIndex?: number;
  point: number[];
  index: number;
  berthMarker?: number;
}

export interface BollardProfile {
  horizontalBreakingStrength: number;
  verticalBreakingStrength: number;
  failurePct: number;
  warningPct: number;
  bollardProfileId: number;
  quickReleaseHook: boolean;
  quickReleaseHookThreshold: number;
  quickReleaseHookNumberOfUnits: number;
}

export interface AutomoorResponse {
  mooringArrangementName: string;
  simulationNotes: SimulationNote[];
  mooringArrangement: Line[];
}

export interface Point3D {
  x: number;
  y: number;
  z: number;
}

export interface MotionCriteria {
  name: number;
  min: number;
  max: number;
  peakToPeak: number;
  acceleration: number | undefined;
}

export interface EnvironmentalConditions {
  wave: Wave;
  current: Current;
  wind: Wind;
  tide: Tide;
  simulationDurationInSeconds?: number;
  forcingInterpolationTimestepInSeconds?: number;
  simulationTimeStepInSeconds?: number;
}

export interface Wave {
  type: ValueType;
  // Wave definition for type 1 and 2
  heightValue: number;
  heightMin: number;
  heightMax: number;
  periodValue: number;
  periodMin: number;
  periodMax: number;
  directionValue: number;
  directionMin: number;
  directionMax: number;
  directionalStandardDeviationBinSize: number;
  // Bin definition for waves:
  heightBinSize: number;
  periodBinSize: number;
  directionBinSize: number;
  // Wave definition strings for type 3 (forecast):
  periodTotalTimeseries: string | undefined;
  directionTotalTimeseries: string | undefined;
  heightTotalTimeseries: string | undefined;
  // Wave matrix conditions
  timeseries: string | undefined;
  scaleFactorTimeseries: string | undefined;
  index: number;
  fileName: string;
  hsSwell?: number;
  tpSwell?: number;
  mwd?: number;
  // Wave Ensemble data:
  ensembleTimeseries?: {
    direction: string;
    height: string;
    period: string;
    controlHeight?: string;
    controlPeriod?: string;
    controlDirection?: string;
    numberOfEnsembles: number;
    numberOfModes: number;
  }

  // Hard coded bins to be used for wave modelling
  waveBins?: {
    height: WaveBin[];
    period: WaveBin[];
    direction: WaveBin[];
  }
}

interface WaveBin {
  lowerBound: number;
  upperBound: number;
}

export interface Current {
  type: ValueType;
  speedValue: number;
  speedBinSize: number;
  speedMin: number;
  speedMax: number;
  speedTimeseries: string | undefined;
  directionBinSize: number;
  directionValue: number;
  directionMin: number;
  directionMax: number;
  directionTimeseries: string | undefined;
}

export interface Wind {
  type: ValueType;
  speedValue: number;
  speedBinSize: number;
  speedMin: number;
  speedMax: number;
  speedTimeseries: string | undefined;
  directionValue: number;
  directionBinSize: number;
  directionMin: number;
  directionMax: number;
  directionTimeseries: string | undefined;
  windSpectraType: 0 | 1 | 2; // 0 = NPD, 1 = Ochi-Shin, 2 = Ochi-Shin with gu = 3 (higher wind speeds)
  windSpeedTimeSpan: number; // Time span for wind speed data to use for wind spectra
}

export interface Tide {
  type: ValueType;
  value: number;
  binSize: number;
  min: number;
  max: number;
  timeseries: string | undefined;
}

export interface Results {
  executedUtc: Date;
  mooringArrangements: { [key: string]: MooringArrangementResult };
  simulationNotes: SimulationNote[];
}

export interface SimulationNote {
  data: string;
  severity: number;
  order: number;
}

export interface MooringNotification {
  notificationType: number;
}

export interface MooringArrangementResult {
  alerts: Alert[];
  windAnalysis: DirectionSpeed[];
  currentAnalysis: DirectionSpeed[];
  draftSpecifics: DraftSpecific[];
  lines: LineResult[];
  bollards: BollardResult[];
  fenders: FenderResult[];
  convergedScenarios: ConvergedScenarios;
  notifications?: MooringNotification[];
}

export interface ConvergedScenarios {
  lineAngles: LineAngle[];
  lineLengths: number[];
  convergedInitialDisplacements: ConvergedInitialDisplacements;
}

export interface ConvergedInitialDisplacements {
  draft: number;
  waterDepth: number;
  lineTension: number;
  fenderFriction: number;
  initialDisplacements: number[];
}

export interface LineAngle {
  horizontal: number;
  vertical: number;
}

export interface Alert {
  alertType: number;
  item: string;
  firstWarning: Date;
  firstFailure: Date;
  description: string;
}

export interface DirectionSpeed {
  direction: number;
  lineSpeed: number;
  bollardSpeed: number;
  fenderSpeed: number;
}

export interface DraftSpecific {
  draft: number;
  longitudinalWindageArea: number;
  transverseWindageArea: number;
  geometricCentreHeight: number;
}

export interface LineResult {
  id: number;
  maxForce: number;
  state: ViolationType;
}

export interface BollardResult {
  id: number;
  maxHorizontalForce: number;
  maxVerticalForce: number;
  horizontalState: ViolationType;
  verticalState: ViolationType;
}

export interface FenderResult {
  id: number;
  maxForce: number;
  state: ViolationType;
}

export interface VesselScenario {
  name: string;
  userName: string;
  debug: boolean;
  runAsDebug: boolean; // If this is set to false and user is debug it will be run as normal user, eg debug = false
  version: number;
  usesCrossScenarioAwareness: boolean;
  mooring: Mooring;
  vessel: Vessel;
  port: Port;
  environmentalConditions: EnvironmentalConditions;
  results: Results | undefined;
  autoGeneratedEvent: boolean;
  debugPortData: boolean;
  scheduleSetValues?: { [key: string]: unknown };
  uniqueId?: string;
}

// };
export interface VesselScenarioContainer extends ScenarioContainer {
  data: VesselScenario;
}

export enum ValueType {
  /** When the data is not used */
  NotUsed = 0,

  /** Use the value */
  Value = 1,

  /** Use the range */
  Range = 2,

  /** Use the Timeseries */
  Timeseries = 3,
}

export enum ViolationType {
  Undefined = 0,
  None = 1,
  Warning = 2,
  Failure = 3,
}
